import { PaperClipOutlined } from "@ant-design/icons";
import { Button, Space, Tooltip, Typography } from "antd";
import InlineAttachmentViewer from "components/molecules/InlineAttachmentViewer";
import AttachmentLightbox from "components/organisms/AttachmentLightbox";
import { useState } from "react";

const { Text } = Typography;

const AttachmentCell = ({ value, showPreview = true, compact = true, piiProtected = false }) => {
    const [lightboxVisible, setLightboxVisible] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);

    if (!value) return null;

    // Detect masked values (e.g. "#####") which are used to hide PII.
    const isMasked = typeof value === "string" && /^#+$/.test(value.trim());

    if (isMasked) {
        if (compact) {
            return (
                <div className="attachment-cell-compact">
                    <Space>
                        <Button type="link" size="small" disabled className="flex items-center text-nowrap">
                            <PaperClipOutlined className="mr-1" />
                            Masked document
                        </Button>
                    </Space>
                </div>
            );
        }

        return (
            <div className="attachment-cell-full">
                <Text>{"Document is PII and has been masked. Preview disabled."}</Text>
            </div>
        );
    }

    let files = [];
    try {
        // value may already be an object/array or a JSON string
        if (typeof value === "string") {
            files = JSON.parse(value);
        } else {
            files = value;
        }

        if (!Array.isArray(files)) {
            files = [files];
        }
    } catch (err) {
        console.error("Error parsing attachment value:", err);
        return null;
    }

    if (files.length === 0) return null;

    const handlePreview = (file, event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const index = files.findIndex((f) => f.key === file.key);
        if (index !== -1) {
            setLightboxIndex(index);
            setLightboxVisible(true);
        }
    };

    const handleCloseLightbox = () => {
        setLightboxVisible(false);
    };

    if (compact) {
        const countText = `${files.length} file(s) attached`;

        return (
            <div className="attachment-cell-compact">
                <Space>
                    {showPreview && files.length > 0 ? (
                        <Tooltip title="Preview image">
                            <Button type="link" size="small" onClick={() => handlePreview(files[0])} className="flex items-center text-nowrap">
                                <PaperClipOutlined className="mr-1" />
                                {countText}
                            </Button>
                        </Tooltip>
                    ) : (
                        <Text className="flex items-center text-nowrap">
                            <PaperClipOutlined className="mr-1" />
                            {countText}
                        </Text>
                    )}
                </Space>

                <AttachmentLightbox visible={lightboxVisible} files={files} currentIndex={lightboxIndex} onClose={handleCloseLightbox} piiProtected={piiProtected} />
            </div>
        );
    }

    return (
        <div className="attachment-cell-full">
            <InlineAttachmentViewer files={files} onPreview={handlePreview} layout="carousel" showControls={showPreview} maxThumbnails={4} className="mt-2" />

            <AttachmentLightbox visible={lightboxVisible} files={files} currentIndex={lightboxIndex} onClose={handleCloseLightbox} piiProtected={piiProtected} />
        </div>
    );
};

export default AttachmentCell;
